export class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.popup = this.querySelector('[data-popup]');
    this.overlay = document.querySelector('.page-overlay');
    this.closeBtn = this.querySelectorAll('[data-close-popup]');
    this.autoOpen = this.hasAttribute('data-auto-open');

    this.checkParams();
    console.log(this.autoOpen);
    console.log(Shopify.designMode);
    if (this.autoOpen && !Shopify.designMode) {
      setTimeout(() => {this.show()}, 1000);
    }

    this.closeBtn.forEach(btn => btn.addEventListener('click', this.hide.bind(this)))

    this.addEventListener('keyup', (event) => {
      if (event.code?.toUpperCase() === 'ESCAPE') this.hide();
    });

    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
    });

    if (this.overlay) {
      this.overlay.addEventListener('click', (e) => {
        const isClickInside = this.contains(e.target);

        if (!isClickInside) this.hide();
      })
    }

    document.addEventListener('click', (e) => {
      const link = e.target.closest('a');
      if (!link) return;

      const href = link.href;
      const url = new URL(href);
      const popupId = url.searchParams.get('popup_open');

      if (!popupId) return;

      const currentUrlBase = window.location.origin + window.location.pathname + window.location.hash;
      const linkUrlBase = url.origin + url.pathname + url.hash;

      if (currentUrlBase === linkUrlBase && popupId === this.id) {
        e.preventDefault();
        this.show();
      }
    })
  }

  checkParams() {
    const params = new URLSearchParams(window.location.search);
    const popupId = params.get('popup_open');
    if (popupId && popupId === this.id) {
      setTimeout(() => {this.show()}, 1000)

      params.delete('popup_open');
      const newUrl =
        window.location.pathname +
        (params.toString() ? '?' + params.toString() : '') +
        window.location.hash;
      window.history.replaceState({}, '', newUrl);
    }
  }

  show(opener) {
    this.openedBy = opener;
    if (this.overlay) this.overlay.setAttribute('aria-hidden', 'false');
    this.popup.setAttribute('aria-hidden', 'false');
    if (this.openedBy) this.openedBy.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('tw-overflow-hidden');

    if (this.popup.querySelector('.cart-view-event')) {
      this.popup.querySelector('.cart-view-event').classList.remove('hide')
    }

    const pdpContainer = document.querySelector("[data-barba='container']");
    if (pdpContainer) pdpContainer.style.zIndex = '50';
  }

  hide() {
    this.popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('tw-overflow-hidden');
    if (this.openedBy) this.openedBy.setAttribute('aria-expanded', 'false');
    if (this.overlay) this.overlay.setAttribute('aria-hidden', 'true');

    const pdpContainer = document.querySelector("[data-barba='container']");
    if (pdpContainer) setTimeout(() => {pdpContainer.style.zIndex = ''}, 300);
  }
}

export class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('[aria-controls]');

    if (!button) return;

    const modalElement = document.querySelector(button.getAttribute('aria-controls'));

    if (!modalElement) return;

    const modal = modalElement.querySelector('[data-popup]');
    button.addEventListener('click', (e) => {
      e.preventDefault();

      if (modal.getAttribute('aria-hidden') === 'false') {
        modalElement.hide();
      } else {
        modalElement.show(button);
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('modal-dialog')) {
    customElements.define('modal-dialog', ModalDialog);
  }

  if (!customElements.get('modal-opener')) {
    customElements.define('modal-opener', ModalOpener);
  }
})